import { useSuspenseHttpQuery } from '@/resources/http/useHttpQuery';
import { isAuthorizedForModule, ModulePermissionTest } from './isAuthorizedForModule';

export const useModulePermissions = () => {
    const { data: modulePermissions } = useSuspenseHttpQuery('GET /my/module-permissions', {}, { staleTime: Infinity });
    return modulePermissions;
};

export const useHasModulePermissions = ({
    requiredPermissions,
    fallbackIfFeatureFlagNotEnabled = true,
}: {
    requiredPermissions: ModulePermissionTest;
    fallbackIfFeatureFlagNotEnabled?: boolean;
}): boolean => {
    const modulePermissions = useModulePermissions();
    const {
        data: { is_advanced_role_management_enabled },
    } = useSuspenseHttpQuery('GET /organization-settings/feature-flags', {}, { staleTime: Infinity });

    if (!is_advanced_role_management_enabled) {
        return fallbackIfFeatureFlagNotEnabled;
    }

    return isAuthorizedForModule(modulePermissions, requiredPermissions);
};
